import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';



export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,  
    activeMarker: {},         
    selectedPlace: {}          
  };

  // 
  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });

    onClose = props => {
      if (this.state.showingInfoWindow) {
        this.setState({
          showingInfoWindow: false,
          activeMarker: null
        });
      }
    };
  render() {
    return (
      <Map
        google={this.props.google}
        zoom={14}
        className = 'map'
        initialCenter={{
         lat: this.props.lat,
         lng: this.props.lng
        }}
      >
        <Marker
        onClick={this.onMarkerClick}
          position = {{
            lat: this.props.lat,
            lng: this.props.lng
           }}
          name={'Kenyatta International Convention Centre'}
        />
        <InfoWindow
        marker={this.state.activeMarker}
        visible={this.state.showingInfoWindow}
        onClose={this.onClose}
        >
            <div>
              <p>{this.props.address}</p>
            </div>
        </InfoWindow>
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDheH4b0_o6SawRCWZXbqRedBlVhDLXyhU'
})(MapContainer);
